import axios, { AxiosInstance } from "axios";
import { API_BASE_URL } from "../apiservices/apiService";

const ApiService: AxiosInstance = axios.create({
  // baseURL: "http://165.22.219.69:5002",
  baseURL: `${API_BASE_URL}`,

  // baseURL: "http://165.22.219.69:5002",
  // timeout: 10000, // optional timeout
  headers: {
    "Content-Type": "multipart/form-data", // Set default headers if needed
  },
});
// Add a response interceptor
// Add a response interceptor
ApiService.interceptors.response.use(
  (response) => {
    // Return a successful response directly
    return response;
  },
  (error) => {
    // Handle any errors globally here
    // For example, you can log the error or show a notification to the user
    // console.log("api jdc");
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      // console.log('Error status:', error.response.status);
      // console.log('Error data:', error.response.data);
      // console.log('Error headers:', error.response.headers);
      // return error.response

      // Customize the error response using the API response data
      const customError = {
        status: error.response.status,
        message: error.response.data.message || "Unknown error occurred",
        // You can include additional information if needed
      };

      // Throw the customized error
      return Promise.reject(customError);
    } else if (error.request) {
      // The request was made but no response was received
      console.log("Error request:", error.request);
      // Handle network errors or timeouts here
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log("Error message:", error.message);
    }

    // Return a rejected promise to propagate the error
    return Promise.reject(error);
  }
);

export default ApiService;
